module.exports = __webpack_public_path__ + "img/roxar-sandlog-wireless.b069a3aa.png";